"use strict";

const wishlistDiv = document.querySelector(".wishlist-page-main");

var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;

      if (!wishlistDiv) return;

      const div_no_product = wishlistDiv.querySelector(
        ".wishlist-no-product-js"
      );

      const storedItems = localStorage.getItem("milano__wishlist-items");

      let wishlist_items = [];

      try {
        wishlist_items = storedItems ? JSON.parse(storedItems) : [];
      } catch (error) {
        console.error("Wishlist localStorage error:", error);
        wishlist_items = [];
      }

      if (!Array.isArray(wishlist_items) || wishlist_items.length === 0) {
        _this.skeletonFunction(0);

        if (div_no_product) {
          div_no_product.classList.remove("hidden");
        }

        return;
      }

      const sectionElement = document.querySelector(
        ".wishlist-page-section"
      );

      if (!sectionElement) {
        console.error("Wishlist section not found.");
        return;
      }

      const section_id = sectionElement.dataset.sectionId;

      /*
       * Build Shopify search query.
       * Example:
       * id:123 OR id:456 OR id:789
       */
      const query = wishlist_items
        .map((id) => `id:${id}`)
        .join(" OR ");

      const params = new URLSearchParams({
        section_id: section_id,
        type: "product",
        "options[unavailable_products]": "last",
        q: query,
      });

      const productAjaxURL = `?${params.toString()}`;

      console.log("Wishlist IDs:", wishlist_items);
      console.log("Wishlist URL:", productAjaxURL);

      fetch(`${window.routes.search_url}${productAjaxURL}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Wishlist request failed: ${response.status}`
            );
          }

          return response.text();
        })
        .then((responseText) => {
          const html = parser.parseFromString(
            responseText,
            "text/html"
          );

          const result = html.querySelector(
            ".wishlist-page-main .wishlist-list-items"
          );

          if (result) {
            const currentList = wishlistDiv.querySelector(
              ".wishlist-list-items"
            );

            if (currentList) {
              currentList.remove();
            }

            wishlistDiv.insertAdjacentHTML(
              "afterbegin",
              result.outerHTML
            );

            _this.skeletonFunction(700);

            if (div_no_product) {
              div_no_product.classList.add("hidden");
            }
          } else {
            console.error(
              "No wishlist products returned from Shopify."
            );

            _this.skeletonFunction(0);

            if (div_no_product) {
              div_no_product.classList.remove("hidden");
            }
          }

          _this.mergeItems();
        })
        .catch((error) => {
          console.error("Wishlist error:", error);

          _this.skeletonFunction(0);

          if (div_no_product) {
            div_no_product.classList.remove("hidden");
          }
        })
        .finally(() => {
          if (typeof initLazyloadItem === "function") {
            initLazyloadItem();
          }
        });
    },

    mergeItems: function () {
      const arr = [];

      if (wishlistDiv) {
        wishlistDiv
          .querySelectorAll(
            ".product-item__action button-wishlist"
          )
          .forEach((element) => {
            const productId = element.dataset.productId;

            if (productId) {
              arr.push(productId);
            }
          });
      }

      localStorage.setItem(
        "milano__wishlist-items",
        JSON.stringify(arr)
      );
    },

    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        const skeleton = document.querySelector("skeleton-page");

        if (skeleton) {
          skeleton.remove();
        }

        const wishlistInner = document.querySelector(
          ".wishlist-page-section-inner"
        );

        if (wishlistInner) {
          wishlistInner.classList.remove("hidden");
        }
      }, timer);
    },
  };
})();

WishlistPageShopify.initWishlistItems();